import { ManadatoryFieldsDataModel, NationalityModel, TitleModel, AreaDataModel, BloodGroups, ReligionDetails, RelationFields, AlternateType, Gender, ProviderCode } from "../../model/index";

export class MandatoryFieldsContainer {

    MandatoryFields: ManadatoryFieldsDataModel[] = [];

    NationalityFields: NationalityModel[] = [];

    GetTitleList: TitleModel[] = [];

    AreaList: AreaDataModel[] = [];

    BloodGroupsList: BloodGroups[] = [];

    RelationFieldsList: RelationFields[] = [];

    ReligionFieldsList: ReligionDetails[] = [];

    AlternateTypeList: AlternateType[] = [];

	BookingType : string = "";    
    ISReligion: string = "";
    AlternateNolength: string = ""; 
    CPRNOlength: string = "";
    HospitalName: string = "";
	GenderList : Gender[] = [];

	ProviderCodeList : ProviderCode[] = [];
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/Registration/MandatoryFieldsContainer.ts